<template>
  <v-layout column align-center v-scroll="searchMore">
    <v-col
      cols="7"
      md="7"
      lg="7"
      xl="7"
      sm="12"
      xs="2"
      xm="2"
      class="mt-8 ml-0"
    >
      <div id="main">
        <v-row :class="{ 'ml-n12': $vuetify.breakpoint.mdAndUp }">
          <span
            class="
              mb-7
              text-right
              display-1
              font-weight-bold
              grey--text
              text--darken-1
            "
          >
            {{ $vuetify.lang.t("$vuetify.TECNICOS") }}</span
          >
        </v-row>

        <v-row id="filtro" class="pl-2 ml-0 grey lighten-5">
          <v-col cols="4" class="pl-4">
            <v-row>
              <span
                class="
                  text-right
                  subtitle-2
                  font-weight-bold
                  grey--text
                  text--lighten-1
                "
              >
                {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="searchText"
                dense
                label="Regular"
                :placeholder="$vuetify.lang.t('$vuetify.NOME_CPF')"
                single-line
                solo
                max-width="200"
                append-icon="mdi-magnify"
                @click:append="search()"
                @keypress.enter="search()"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col class="mt-7 ml-3">
            <TooltipButton
              v-if="$hasPermission('TECNICOS-NOVO', [])"
              :label="$vuetify.lang.t('$vuetify.NOVO_TECNICO')"
              :message="$vuetify.lang.t('$vuetify.NOVO_TECNICO')"
              :event="create"
              :mobile="$vuetify.breakpoint.xs"
              :isText="false"
            ></TooltipButton>
          </v-col>
        </v-row>

        <v-row class="pl-2 pr-2" style="margin-left: -2px">
          <v-expansion-panels class="ma-1">
            <v-expansion-panel
              v-for="(tecnico, i) in tecnicos"
              :key="i"
              hide-actions
              :disabled="disabled"
            >
              <v-expansion-panel-header style="z-index: 1000">
                <v-row align="center" no-gutters>
                  <v-col v-show="!$vuetify.breakpoint.xs" sm="5" md="4">
                    <strong
                      class="subtitle-2 font-weight-bold"
                      v-html="tecnico.nome"
                    ></strong>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row
                  class="mt-3 ml-1"
                  :class="{ 'pl-10 pt-3 ml-n5': $vuetify.breakpoint.xs }"
                >
                  <v-col
                    class="pt-0 pl-0 pr-0 mt-n6 col-4"
                    :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                  >
                    <LabelValue
                      :label="$vuetify.lang.t('$vuetify.NOME')"
                      :value="tecnico.nome ? tecnico.nome : '--'"
                      justify="start"
                      style="width: 350px"
                      truncate
                    ></LabelValue>
                  </v-col>

                  <v-col
                    class="pt-0 pl-0 pr-0 mt-n6 col-4"
                    :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                  >
                    <LabelValue
                      label="CPF"
                      :value="tecnico.cpf ? tecnico.cpf : '--'"
                      justify="start"
                      style="width: 350px"
                      truncate
                    ></LabelValue>
                  </v-col>

                  <v-col
                    class="pt-0 pl-0 pr-0 mt-n6 col-4"
                    :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                  >
                    <LabelValue
                      :label="$vuetify.lang.t('$vuetify.INSTALADORA')"
                      :value="tecnico.instaladora ? tecnico.instaladora.nome : '--'"
                      justify="start"
                      style="width: 350px"
                      truncate
                    ></LabelValue>
                  </v-col>
                </v-row>

                <v-divider class="mt-0"></v-divider>

                <v-card-actions class="mb-n3">
                  <TooltipButton
                    v-if="$hasPermission('TECNICOS-NOVO', [])"
                    :label="$vuetify.lang.t('$vuetify.EDITAR')"
                    :message="$vuetify.lang.t('$vuetify.EDITAR_TECNICO')"
                    :event="edit"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="tecnico"
                  ></TooltipButton>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row justify="center">
          <v-progress-circular
            v-if="isLoading"
            :size="30"
            :width="4"
            color="blue darken-2"
            indeterminate
            class="ml-n2 mt-3 mb-n1 text-center"
          ></v-progress-circular>
        </v-row>
        <v-row justify="center" v-if="tecnicos.length == 0 && !isLoading">
          <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
            <WarningPanel
              v-if="!isLoading"
              :message="$vuetify.lang.t('$vuetify.NENHUM_TECNICO')"
            >
            </WarningPanel>
          </v-lazy>
        </v-row>
      </div>
    </v-col>

     <TechnicianFormDialog
      :dialog="showDialog"
      :tecnico="selectedTecnico"
      :instaladoras="instaladoras"
      :close="closeDialog"
      :send="send"
      :isLoading="isLoading"
      :showTecnicoAlreadyExists="showTecnicoAlreadyExists"
    ></TechnicianFormDialog>
  </v-layout>
</template>

<script>
import WarningPanel from "../components/panels/WarningPanel";
import TooltipButton from "../components/TooltipButton";
import LabelValue from "../components/LabelValue";
import TechnicianFormDialog from "../components/dialogs/TechnicianFormDialog";

export default {
  components: {
    WarningPanel,
    TooltipButton,
    LabelValue,
    TechnicianFormDialog,
  },
  methods: {
    edit(tecnico) {
      this.selectedTecnico = Object.assign({}, tecnico);
      this.showDialog = true;
    },
    hasEmptyFields(tecnico) {
      return (
        !tecnico.nome ||
        !tecnico.cpf || !tecnico.instaladora 
      );
    },
    send(tecnico) {
      if (this.hasEmptyFields(tecnico)) {
        return;
      }

      this.showTecnicoAlreadyExists = false;
      this.isLoading = true;

      if (!tecnico.id) {
        this.$post("/tecnico/save", tecnico).then((response) => {
          if (!response.data) {
            this.showTecnicoAlreadyExists = true;
            this.isLoading = false;
            return;
          }

          var element = document.getElementById("main");

          this.$vuetify.goTo(element, {
            duration: 200,
            offset: 25,
            easing: "linear",
          });

          setTimeout(() => this.tecnicos.unshift(response.data), 650);
          this.$root.$emit("invalidateFields");

          this.isLoading = false;
          this.showDialog = false;
        });

        return;
      }

      this.$post("/tecnico/save", tecnico).then((t) => {
        var vm = this;
        this.tecnicos.forEach(function (h, i) {
          if (h.id == t.data.id) {
            vm.tecnicos[i] = t.data;
          }
        });

        this.$root.$emit("invalidateFields", true);
        this.isLoading = false;
        this.showDialog = false;
      });
    },
    create() {
      this.selectedTecnico = {};
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    searchMore() {
      this.stickFilters();

      if (this.isLoding || this.noResult) {
        return;
      }

      if (
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.scrollHeight
      ) {
        this.page++;
        this.search(this.page);
      }
    },
    search(page) {
      this.isLoading = true;
      if (!page) {
        this.page = 0;
        this.tecnicos = [];
        this.noResult = false;
      }

      this.$get("/tecnico/busca", {
        searchText: this.searchText,
        page: this.page,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.tecnicos = this.tecnicos.concat(response.data);
        this.isLoading = false;
      });
    },
    stickFilters() {
      if (document.documentElement.scrollTop > 95) {
        document.getElementById("filtro").style =
          "position:sticky; z-index:2; top:66px; box-shadow: 0 0 10px #333; border-radius: 15px;";
      } else if (document.documentElement.scrollTop < 60) {
        document.getElementById("filtro").style = "";
      }
    },
  },
  data: () => ({
    page: 0,
    isLoading: false,
    noResult: false,
    searchText: "",
    tecnicos: [],
    showDialog: false,
    disabled: false,
    selectedTecnico: undefined,
    showTecnicoAlreadyExists: false,
  }),
  created: function () {
    this.isLoading = true;
    this.$get("/tecnico/busca", { searchText: this.searchText, page: 0 }).then((response) => {
      this.tecnicos = response.data;
      this.isLoading = false;
    });

    this.$get("/instaladora/all", {}).then((response) => {
      this.instaladoras = response.data;
    });
  },
};
</script>
